import React from 'react';
import './ChatSkeleton.css';

function ChatSkeleton() {
  return (
    <div className="chat-skeleton-list">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="chat-skeleton-item">
          <div className="chat-skeleton-avatar" />

          <div className="chat-skeleton-info">
            <div className="chat-skeleton-top-row">
              <div className="chat-skeleton-name" />
              <div className="chat-skeleton-time" />
            </div>

            <div className="chat-skeleton-text" />
          </div>

          <div className="chat-skeleton-delete" />
        </div>
      ))}
    </div>
  );
}

export default ChatSkeleton;
